module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-06.fdf3be7d.jpg";